import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';

import { Message } from '@app/models/conversation/message.model';

import { environment } from '../../../environments/environment';

@Injectable()
export class MessageService {
  baseHref = `${environment.apiUrl}/messages`;

  constructor(private http: HttpClient) {}

  readMessagesForConversation(conversationId: number): Observable<boolean> {
    const url = `${this.baseHref}/conversation/${conversationId}/readall`;
    return this.http.get<boolean>(url);
  }

  getNewMessagesCount(): Observable<{ numMessages: number }> {
    const url = `${this.baseHref}/count/new`;
    return this.http.get<{ numMessages: number }>(url);
  }

  sendMessage(messageData): Observable<Message> {
    const url = `${this.baseHref}`;
    return this.http.post<any>(url, messageData);
  }
}
